import { Fragment } from 'react'

import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  useTableRowModClassName,
} from '../../../../Table'

import {
  getIsApplicantProfileEmailsRowActive,
  renderApplicantProfileEmailsCell,
} from './ApplicantProfileEmailsRow.utils'

import * as styles from './ApplicantProfileEmailsRow.module.css'

function ApplicantProfileEmailsRow({
  columns,
  emptyColumnSize,
  focusedRow,
  getArrowNavigationItemProps,
  index,
  isResizing,
  item,
  resizingColumn,
  showCellBorder,
}) {
  const className = useTableRowModClassName({
    className: styles.ApplicantProfileEmailsRow,
    isActive: getIsApplicantProfileEmailsRowActive({ focusedRow, item }),
  })

  // TODO: open the message on click once the backend serves an applicant-scoped
  // message read (body and attachments); the feed only carries the snippet
  return (
    <div
      {...getTableRowQaProps()}
      {...getArrowNavigationItemProps?.(index)}
      className={className}
    >
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderApplicantProfileEmailsCell({
            isActive: column.name === resizingColumn,
            isResizing,
            item,
            name: column.name,
            showCellBorder,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
    </div>
  )
}

export default ApplicantProfileEmailsRow
